/**
 * Assets del producto DPS43 · Troop Night Ready.
 *
 * MAIN_MOCKUP_URL: pegá acá la URL pública del mockup principal
 * (Drive > mockup > "DPS43 - Principal - Troop Night Ready.png", subido a
 * Magic Patterns o a ImpulTienda). Mientras esté vacío, el hero y el pricing
 * muestran un abanico con páginas reales del Volumen 2.
 */
export const MAIN_MOCKUP_URL = ''

/** Páginas reales del Volumen 2 (Gamma), formato 9:16. */
export const PAGE_IMAGES = {
  cover:
    'https://cdn.gamma.app/l3kmqaoww92vn95/generated-images/0Etcih1wl4aWTWM_.jpg',
  formula:
    'https://cdn.gamma.app/l3kmqaoww92vn95/generated-images/FPH_kHq4MV392wkX.jpg',
  meetingCard:
    'https://cdn.gamma.app/l3kmqaoww92vn95/generated-images/1ygesU2n01ISJdR4.jpg',
  skillStation:
    'https://cdn.gamma.app/l3kmqaoww92vn95/generated-images/D6WCTdc29Yg2zdzA.jpg',
  patrolChallenge:
    'https://cdn.gamma.app/l3kmqaoww92vn95/generated-images/SlGgdBiPlYjjJ1Hh.jpg',
  wrongRight:
    'https://cdn.gamma.app/l3kmqaoww92vn95/generated-images/7HWig-JKzCjH8SHE.jpg',
  worksheet:
    'https://cdn.gamma.app/l3kmqaoww92vn95/generated-images/-Rq0fxV_9344Brfz.jpg',
}
